const contries = [
  { name: "Afghanistan", code: "AF" },
  { name: "Afrique du Sud", code: "ZA" },
  { name: "Åland, Îles", code: "AX" },
  { name: "Albanie", code: "AL" },
  { name: "Algérie", code: "DZ" },
  { name: "Allemagne", code: "DE" },
  { name: "Allemagne de l'EST", code: "DD" },
  { name: "Andorre", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Anguilla", code: "AI" },
  { name: "Antarctique", code: "AQ" },
  { name: "Antigua et Barbuda", code: "AG" },
  { name: "Antilles néerlandaises", code: "AN" },
  { name: "Arabie Saoudite", code: "SA" },
  { name: "Argentine", code: "AR" },
  { name: "Arménie", code: "AM" },
  { name: "Aruba", code: "AW" },
  { name: "Australie", code: "AU" },
  { name: "Autriche", code: "AT" },
  { name: "Azerbaïdjan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrein", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbade", code: "BB" },
  { name: "Bélarus", code: "BY" },
  { name: "Belgique", code: "BE" },
  { name: "Bélize", code: "BZ" },
  { name: "Bénin", code: "BJ" },
  { name: "Bermudes", code: "BM" },
  { name: "Bhoutan", code: "BT" },
  { name: "Bolivie (État plurinational de)", code: "BO" },
  { name: "Bosnie-Herzégovine", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Brésil", code: "BR" },
  { name: "Brunéi Darussalam", code: "BN" },
  { name: "Bulgarie", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cabo Verde", code: "CV" },
  { name: "Cambodge", code: "KH" },
  { name: "Cameroun", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Chili", code: "CL" },
  { name: "Chine", code: "CN" },
  { name: "Chypre", code: "CY" },
  { name: "Colombie", code: "CO" },
  { name: "Comores", code: "KM" },
  { name: "Congo", code: "CG" },
  { name: "Congo, République démocratique du", code: "CD" },
  { name: "Corée du Sud", code: "KR" },
  { name: "Corée du Nord", code: "KP" },
  { name: "Costa Rica", code: "CR" },
  { name: "Côte d'Ivoire", code: "CI" },
  { name: "Croatie", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Danemark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominique", code: "DM" },
  { name: "Égypte", code: "EG" },
  { name: "Émirats arabes unis", code: "AE" },
  { name: "Équateur", code: "EC" },
  { name: "Érythrée", code: "ER" },
  { name: "Espagne", code: "ES" },
  { name: "Estonie", code: "EE" },
  { name: "États-Unis", code: "US" },
  { name: "Éthiopie", code: "ET" },
  { name: "Finlande", code: "FI" },
  { name: "France", code: "FR" },
  { name: "Gabon", code: "GA" },
  { name: "Gambie", code: "GM" },
  { name: "Géorgie", code: "GE" },
  { name: "Ghana", code: "GH" },
  { name: "Grèce", code: "GR" },
  { name: "Guatemala", code: "GT" },
  { name: "Guinée", code: "GN" },
  { name: "Haïti", code: "HT" },
  { name: "Honduras", code: "HN" },
  { name: "Hongrie", code: "HU" },
  { name: "Inde", code: "IN" },
  { name: "Indonésie", code: "ID" },
  { name: "Iran", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Irlande", code: "IE" },
  { name: "Islande", code: "IS" },
  { name: "Israël", code: "IL" },
  { name: "Italie", code: "IT" },
  { name: "Jamaïque", code: "JM" },
  { name: "Japon", code: "JP" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Liban", code: "LB" },
  { name: "Libye", code: "LY" },
  { name: "Madagascar", code: "MG" },
  { name: "Malaisie", code: "MY" },
  { name: "Mali", code: "ML" },
  { name: "Maroc", code: "MA" },
  { name: "Mexique", code: "MX" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolie", code: "MN" },
  { name: "Nigéria", code: "NG" },
  { name: "Norvège", code: "NO" },
  { name: "Nouvelle-Zélande", code: "NZ" },
  { name: "Pakistan", code: "PK" },
  { name: "Pays-Bas", code: "NL" },
  { name: "Pérou", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Pologne", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "République Tchèque", code: "CZ" },
  { name: "Roumanie", code: "RO" },
  { name: "Royaume-Uni", code: "GB" },
  { name: "Russie", code: "RU" },
  { name: "Sénégal", code: "SN" },
  { name: "Singapour", code: "SG" },
  { name: "Suède", code: "SE" },
  { name: "Suisse", code: "CH" },
  { name: "Thaïlande", code: "TH" },
  { name: "Tunisie", code: "TN" },
  { name: "Turquie", code: "TR" },
  { name: "Ukraine", code: "UA" },
  { name: "Venezuela", code: "VE" },
  { name: "Vietnam", code: "VN" },
  { name: "Zambie", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" }
];

export default contries;
